import { useCallback, useEffect, useState, useMemo } from "react";
import { MetaTags } from "react-meta-tags";
import styled from "styled-components";
import Logo from "../components/Logo/Logo";
import Header from "../components/Header/Header";
import Navigation from "../components/Navigation/Navigation";
import Footer from "../components/Footer/Footer";
import API from "../api";
import { clearLocalStorage, setLocalStorage } from "../utils";
import { RESPONSE_STATUSES } from "../constants";
import AuthSlider from "../components/Slider/AuthSlider";
import ScrollMessage from "../components/ScrollMessage/ScrollMessage";
import PublicHeader from "../screens/Home/comp/Header";
import PublicFooter from "../screens/Home/comp/Footer";

// const StyledAuthMainOuter = styled.section`
//   width: calc(100% - 100px);
//   height: calc(100% - 100px);
//   background-color: #fff3e9;
//   position: fixed;
//   top: 0;
//   left: 0;
//   display: flex;
//   justify-content: center;
//   padding: 50px;
//   @media (max-width: 1000px) {
//     width: 100%;
//     padding: 0px;
//     height: 100%;
//   }
// `;

// const StyledMainSection = styled.section`
//   background-color: rgb(255, 255, 255);
//   box-shadow: 0px 5px 15px -10px #000000;
//   width: 100%;
//   max-width: 1200px;
//   height: auto;
//   margin: 0px;
//   display: flex;
//   flex-direction: row-reverse;
//   column-gap: 30px;
//   padding: 30px;
//   border-radius: 30px;
//   @media (max-width: 1000px) {
//     width: 100%;
//     display: flex;
//     padding: 10px;
//     height: 100% !important;
//     border-radius: 0;
//     justify-content: center;
//     align-items: flex-start;
//   }
// `;

// const StyledAuthHeader = styled.section`
//   width: 100%;
//   height: auto;
//   text-align: center;
//   display: none;
//   @media (max-width: 1000px) {
//     display: flex;
//   }
// `;

// const StyledAuthFormSection = styled.section`
//   width: 50%;
//   height: auto;
//   margin: 0px;
//   padding: 0px;
//   overflow-y: scroll;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex-direction: column;
//   @media (max-width: 1000px) {
//     width: 100%;
//   }
//   ::-webkit-scrollbar {
//     display: none;
//   }
// `;

// const StyledAuthFormIn = styled.section`
//   width: 350px;
//   height: 100%;
//   display: ${({ screentype }) => (screentype === "Full" ? "block" : "flex")};
//   flex-direction: column;
//   justify-content: center;

//   @media (max-width: 1000px) {
//     width: 95%;
//     max-width: 350px;
//   }
// `;

// const StyledContentArea = styled.section`
//   width: 60%;
//   height: 100%;
//   img {
//     width: 100%;
//     height: 100%;
//     border-radius: 30px;
//   }
//   @media (max-width: 1000px) {
//     display: none;
//   }
// `;

// New

const StyledAuthContainer = styled.section`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  margin: 0px;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: #ffffff;
`;

const StyledAuthContainerIn = styled.section`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-height: 800px) {
    justify-content: flex-start;
  }
      @media (max-width: 1000px) {
    justify-content: flex-start;
  }
`;

const StyledSliderContainerIn = styled.section`
  height: inherit;
  padding: 50px;
`;

const StyledAuthFormContainer = styled.section`
  flex: 2;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const StyledAuthHeading = styled.h1`
  font-weight: 800;
  font-size: 40px;
  margin: 10px 0px;
`;

const StyledAuthSubtext = styled.p`
  color: #656565ff;
  text-align: center;
  line-height: 20px;
  margin: 5px 0px;
`;

const StyledFormOuter = styled.section`
  width: auto;
  min-width: 400px;
  height: auto;
  margin: 0px;
  padding: 0px 20px 40px 20px;
`;

// display: flex;
//   flex-direction: column;

const StyledAuthSliderContainer = styled.section`
  flex: 3;
  height: inherit;

  @media (max-width: 1000px) {
    display: none;
  }
`;

const StyledSliderOuter = styled.section`
  height: calc(100% - 100px);
  margin: 50px;
  background-color: #fff3e9;
  border-radius: 50px;
`;

const SliderContainer = styled.section`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const widthAuthHOC = (Component, isLogin = false) => (props) => {
  const { appData = {} } = props || {};
  const {
    appName = "App",
    appLogo = "/logo.png",
    bannerImages = [],
  } = appData;

  /* ================= FILTER SLIDES ================= */
  const sliderImages = useMemo(() => {
    if (!Array.isArray(bannerImages)) return [];
    return bannerImages.filter((i) => i?.type === "Authentication");
  }, [bannerImages]);

  return (
    <div style={styles.wrapper}>

      {/* ================= LEFT: FORM ================= */}
      <div style={styles.leftPanel}>
        <div style={styles.card}>

          {/* LOGO */}
          <div style={styles.logoWrap}>
            <img src={appLogo} alt={appName} style={styles.logo} />
          </div>

          {/* HEADER (ONLY FOR LOGIN) */}
          {isLogin && (
            <div style={styles.header}>
              <h2 style={styles.title}>Welcome back</h2>
              <p style={styles.subtitle}>
                Secure access to your recharge dashboard
              </p>
            </div>
          )}

          {/* FORM */}
          <div style={styles.formWrap}>
            <Component {...props} />
          </div>
        </div>
      </div>

      {/* ================= RIGHT: SLIDER ================= */}
      {isLogin && sliderImages.length > 0 && (
        <div style={styles.rightPanel}>
          <div style={styles.sliderOverlay} />

          <div style={styles.sliderContent}>
            <AuthSlider images={sliderImages} />
          </div>
        </div>
      )}
    </div>
  );
};

/* ================= MODERN STYLES ================= */
const styles = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
    width: "100%",
    background: "linear-gradient(135deg, #0b1220, #05070d)",
  },

  /* LEFT */
  leftPanel: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 20px",
  },

  card: {
    width: "100%",
    maxWidth: "420px",
    padding: "32px 26px",
    borderRadius: "18px",
    background: "rgba(255,255,255,0.06)",
    backdropFilter: "blur(18px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
  },

  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "18px",
  },

  logo: {
    height: "250px",
    objectFit: "contain",
  },

  header: {
    textAlign: "center",
    marginBottom: "20px",
  },

  title: {
    color: "#fff",
    fontSize: "22px",
    margin: 0,
  },

  subtitle: {
    color: "rgba(255,255,255,0.65)",
    fontSize: "13px",
    marginTop: "6px",
  },

  formWrap: {
    marginTop: "10px",
  },

  /* RIGHT */
  rightPanel: {
    flex: 1,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },

  sliderOverlay: {
    position: "absolute",
    inset: 0,
    background:
      "radial-gradient(circle at center, rgba(255,185,123,0.12), transparent 60%)",
  },

  sliderContent: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  fallbackText: {
    color: "#fff",
    fontSize: "28px",
    fontWeight: "600",
  },
};

const withAppHOC = (Component) => (props) => {
  const [profile, setProfile] = useState(null);
  const [scrollMessage, setScrollMessage] = useState("");
  const [showNav, setShowNav] = useState(false);

  const readScrollMessage = useCallback(async () => {
    const response = await API.get("/meta/scroll-message");
    const { status, data } = response.data;
    if (status === RESPONSE_STATUSES.SUCCESS) {
      setScrollMessage(data);
    }
  }, []);

  const readProfile = useCallback(async () => {
    const response = await API.get("/authentication/profile");
    const { status, data } = response.data;
    if (status === RESPONSE_STATUSES.SUCCESS) {
      setProfile(data);
      setLocalStorage("userProfile", JSON.stringify(data));
    }
  }, []);

  const onClickLogout = (e) => {
    e.preventDefault();
    API.delete("/authentication/logout");
    clearLocalStorage();
    window.location.href = "/login";
  };

  const onClickNavigationIcon = () => {
    setShowNav((showNav) => !showNav);
  };

  useEffect(() => {
    readProfile();
    readScrollMessage();
  }, [readProfile, readScrollMessage]);

  return (
    <>
      <Header
        fullName={profile?.firstName ? profile.firstName : "My Account"}
        {...profile}
        onClickLogout={onClickLogout}
        showNav={showNav}
        setShowNav={onClickNavigationIcon}
        {...props}
      />
      <Navigation {...props} showNav={showNav} />
      <ScrollMessage scrollMessage={scrollMessage} />
      <Component {...props} />
      <Footer {...props} />
    </>
  );
};

const withPublicHOC =
  (Component) =>
    ({ appData }) => {
      return (
        <>
          <MetaTags>
            <link
              href="https://fonts.googleapis.com/css?family=Poppins:200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i&display=swap"
              rel="stylesheet"
            />

            <link rel="stylesheet" href="css/bootstrap.min.css" />
            <link rel="stylesheet" href="css/normalize.css" />
            <link rel="stylesheet" href="css/style.css" />
            <link rel="stylesheet" href="css/responsive.css" />
            <link rel="stylesheet" href="css/color/color1.css" />
            <link rel="stylesheet" id="colors" />
          </MetaTags>
          <PublicHeader {...appData} />
          <Component {...appData} />
          <PublicFooter {...appData} />
          <script src="js/jquery.min.js"></script>
          <script src="js/bootstrap.min.js"></script>
          <script src="js/main.js"></script>
        </>
      );
    };

export { widthAuthHOC, withAppHOC, withPublicHOC };
